import type { User } from '@/models/User';

import identifyUser from './identifyUser';
import { initializeMixpanel, identifyUser as mixpanelIdentifyUser } from './mixpanel';

import { isAnalyticsEnabled } from '@/utils/storage';

export function initializeAnalytics(user: User | undefined, locale: string) {
  if (user && isAnalyticsEnabled()) {
    Promise.all([initializeMixpanel()]).then(() => {
      identifyUser(user, [mixpanelIdentifyUser], locale);
    });
  }
}
